import { useEffect, useMemo, useState } from 'react';
import { createElement } from 'react';
import { createBrowserRouter } from 'react-router';
import { getRouter } from '../../getRouter';
import { useMeQuery } from '../../apiHooks/useMeQuery';
import { useAuthStore } from '../../components/Login/useAuthStore';
import { useIsPermittedOrigin } from '../../appState/hooks/useOrigin';
import { ErrorView } from '../../components/ErrorView';
import { getDeactivatedAccessMessage } from '../functional/getDeactivatedAccessMessage';

export function useRouter() {
  const location = window.location;
  const otpRequested = useAuthStore((state) => state.loginStatus) === 'otpRequested';
  const loginStatus = useAuthStore((state) => state.loginStatus);
  const { setError } = useAuthStore();

  const [origin, setOrigin] = useState(location.origin);
  useEffect(() => {
    setOrigin(location.origin);
  }, [location.origin]);
  const { data: meData, error: meError } = useMeQuery();
  const isPermittedOrigin = useIsPermittedOrigin();
  const deactivatedMessage = getDeactivatedAccessMessage(meError);

  useEffect(() => {
    if (deactivatedMessage) {
      setError(deactivatedMessage);
    }
  }, [deactivatedMessage, setError]);

  const router = useMemo(() => {
    if (deactivatedMessage) {
      return createBrowserRouter([
        {
          path: '*',
          element: createElement(ErrorView, { error: { message: deactivatedMessage } }),
        },
      ]);
    }
    return getRouter({
      origin,
      otpRequested,
      isManager: meData ? meData.portalRole === 'manager' : undefined,
      loginStatus,
      isPermittedOrigin,
    });
  }, [origin, otpRequested, meData, loginStatus, isPermittedOrigin, deactivatedMessage]);

  return router;
}
